import { IS_COPYING_VALUE } from "@hub/settings/src/constants"

export default {
  currentStep: state => state.currentStep,
  loading: state => state.loading,
  steps: state => state.steps,
  stepsNamesRoutes: state => state.stepsNamesRoutes,
  getFlow: state => state.flow,
  isCopying: state => state.isCopying,
  isEditing: state => state.isEditing,
  isSelectAllRoles: state => state.isSelectAllRoles,
  uuid: state => state.uuid,
  getFlowPayload: state => {
    const flow = state.flow
    const payload = {
      name: flow.title,
      connector_uuid: flow.integrator,
      icon: flow.icon,
      roles: flow.roles,
      duplicated: state.isCopying ? IS_COPYING_VALUE.active : IS_COPYING_VALUE.inactive,
      initial_sale_status_id: flow.initialStatus,
      person_type: flow.personType,
      has_installation_schedule: flow.hasScheduling
    }

    if (!state.isEditing) {
      payload.flows = flow.saleFlow
    }

    return payload
  }
}